/**
 * Normalizes and validates in-app redirect targets (HashRouter paths).
 * Rejects open redirects, schemes, and path traversal.
 */
export function sanitizeInternalRedirectPath(
  raw: string | null | undefined
): string | null {
  if (raw == null || typeof raw !== 'string') {
    return null;
  }

  let path = raw.trim();
  if (!path) {
    return null;
  }

  if (path.startsWith('#')) {
    path = path.replace(/^#\/?/, '/');
  }

  if (!path.startsWith('/')) {
    path = `/${path}`;
  }

  if (path.startsWith('//')) {
    return null;
  }

  if (/^[a-zA-Z][a-zA-Z+\-.]*:/.test(path)) {
    return null;
  }

  if (path.includes('://')) {
    return null;
  }

  if (path.includes('..')) {
    return null;
  }

  if (path.length > 2048) {
    return null;
  }

  return path;
}
